var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bannerS',{staticClass:"nav"}),_vm._v(" "),_c('navS',{class:{ 'fixed-nav': _vm.navFixed }}),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('model'),_vm._v(" "),_c('footerS')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d36bc66","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/portal.vue
// module id = null
// module chunks = 